<div
  class="chat-internal-widget"
  [ngClass]="{ minimized: status === s.minimized, maximized: status === s.maximized }"
>
  <div class="header" (click)="toggleWidget()">
    <div class="cp" style="margin-right: auto">
      <p class="nmb fw500">Lara</p>
    </div>
    <button mat-icon-button (click)="toggleWidget(); $event.stopPropagation()">
      <mat-icon>{{ status === s.maximized ? 'remove' : 'open_in_full' }}</mat-icon>
    </button>
    <app-chat-internal-preferences
      (click)="$event.stopPropagation()"
    ></app-chat-internal-preferences>
  </div>
  <div *ngIf="status === s.maximized" class="chat-body">
    <app-chat-internal-sidebar
      [selectedConversationId]="selectedConversationId"
      (selectConversation)="onSelectConversation($event)"
      (newConversation)="onNewConversation()"
    >
    </app-chat-internal-sidebar>
    <div class="chat-main">
      <app-chat-internal-messages [conversationId]="selectedConversationId">
      </app-chat-internal-messages>
      <app-chat-internal-input
        [conversationId]="selectedConversationId"
        (messageSent)="onMessageSent($event)"
      >
      </app-chat-internal-input>
    </div>
  </div>
</div>
